import { getIsApp } from '../../../../modules/AppInfo';
import {
  INavigator,
  INavigatorShareData,
  isAnonymous,
  IShareParams,
  ShareChannelFactory,
  ShareChannelMap,
  ShareProvider,
  ShareTarget,
  socialSharing,
} from '../../../../modules/share';
import { IS_MINE_MESSAGE } from '../constants';
import { providerAtSalon, getProfileShareImage, getShareText } from './helpers';

// Note: Re-ported the following code to stay close to the original from socialShare.js
const handleShare = async (
  params: IShareParams,
  onSuccess,
  onFail,
) => {
  const Nav: INavigator = navigator as unknown as INavigator;
  if (getIsApp() && socialSharing()) {
    socialSharing().share(
      params.text,
      params.title,
      params.image as string,
      null,
      onSuccess,
      onFail,
    );
  } else if (Nav.share) {
    const { image, url, ...restData } = params;
    const blob = await fetch(image as string).then(r => r.blob());
    const files = [new File([blob], 'share.jpg', { type: 'image/jpeg' })];
    const shareData: INavigatorShareData = { ...restData, files, url: url?.toString?.() };

    if (Nav.canShare && !Nav.canShare({ files })) {
      delete shareData.files;
    }

    try {
      await Nav.share(shareData);
      onSuccess();
    } catch (error) {
      onFail(error);
    }
  }
};

type ShareContent = {
  title: string;
  text: string;
};

const getProfileShareText = (
  provider: ShareProvider,
  url: string,
  isMine?: boolean,
): ShareContent => ({
  title: `Book an appointment online with ${provider.name} | StyleSeat`,
  text: isMine
    ? `${IS_MINE_MESSAGE}: ${url}`
    : `Book an appointment online with ${providerAtSalon(provider)}: ${url}`,
});

const getPlatformShareText = (url, isMine): ShareContent => ({
  title: 'Book an appointment online with StyleSeat | StyleSeat',
  text: isMine
    ? `${IS_MINE_MESSAGE}: ${url}`
    : `Book an appointment online with StyleSeat: ${url}`,
});

const profileShare: ShareChannelFactory<ShareProvider | null> = (
  provider,
  url,
  user,
  onSuccess,
  onFail,
  message = {},
) => {
  let content: ShareContent;
  let isMine: boolean;
  let image: string;
  if (provider) {
    isMine = !isAnonymous(user) && provider.id === user.provider_id;
    content = getProfileShareText(provider, url, isMine);
    image = getProfileShareImage(provider);
  } else {
    isMine = false;
    content = getPlatformShareText(url, isMine);
    image = null;
  }

  const params = {
    title: message.title || content.title,
    text: getShareText(message.url || url, content.text, isMine, message.text),
    image: message.image || image,
    url: message.url || url,
  };

  return () => {
    handleShare(params, onSuccess, onFail);
  };
};

const MAP: ShareChannelMap = {
  [ShareTarget.PROFILE]: profileShare,
  [ShareTarget.SEARCH]: profileShare,
  [ShareTarget.PLATFORM]: profileShare,
};

export default MAP;
